module.exports = __webpack_public_path__ + "static/media/history_20.8f51c78c.jpg";